import * as React from "react";

const Main = (props: {children?: React.ReactNode}) => (
    <main className="ll-main">
        {props.children}
    </main>
);

export default Main;